/* VerifiedDoctorBadge — small trust signal next to a doctor's name on
 * public-facing surfaces (Find a Doctor cards, BookAppointment hero,
 * doctor profile pages).
 *
 * Renders the seal icon + "DCI verified" pill. Hidden when the doctor
 * doc lacks `dci_verified === true` so the badge truly means something
 * (and so we never make false trust claims).
 */
import React from "react";
import { SealCheck } from "@phosphor-icons/react";

export function VerifiedDoctorBadge({ doctor, size = "md", className = "" }) {
    // Treat the badge as opt-in: only show when the doctor record has been
    // explicitly verified (admin-set), never by absence of data.
    const verified = doctor?.dci_verified === true
        || doctor?.is_verified === true
        || doctor?.verified === true;
    if (!verified) return null;

    const sm = size === "sm";
    const px = sm ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-[11px]";
    const iconSize = sm ? 11 : 13;

    return (
        <span
            className={`inline-flex items-center gap-1 rounded-full font-semibold bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200 ${px} ${className}`}
            title="Verified by the Indian Dental Council · identity, registration and clinic credentials confirmed"
            data-testid="verified-doctor-badge"
        >
            <SealCheck size={iconSize} weight="fill" className="text-emerald-600" />
            DCI verified
        </span>
    );
}

export default VerifiedDoctorBadge;
